import React, { Component, useState, useEffect, useRef } from 'react'
import Grid from '@mui/material/Grid'
import { Box, Avatar, Stack, Tabs, Tab, Divider, Chip, Button } from '@mui/material'
import MUIIconButton from '@mui/material/IconButton'
import {IconButton} from '../../../assets/Buttons'
import * as Icons from '../../../assets/Icons'
import CircularProgress from '@mui/material/CircularProgress'
import { Paragraph, Tip, Text } from '../../../assets/Text'
import { TextInput } from '../../../assets/Form'
import { MessengerInput } from '../../../assets/Chat'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AuthenticationHelper from '../../../helpers/AuthenticationHelper'
import UserInteractionHelper from '../../../helpers/UserInteractionHelper'
import AiInteractionHelper from '../../../helpers/AiInteractionHelper'
import ChatSystemHelper from '../../../helpers/ChatSystemHelper'
import ChatInfoStore from '../../../helpers/ChatInfoStore'
import ChatSocketHelper from '../../../helpers/ChatSocketHelper'
import AIChatHelper from '../../../helpers/AIChatHelper'
import AIProfileHelper from '../../../helpers/AIProfileHelper'
import UserProfileHelper from '../../../helpers/UserProfileHelper'
import GetImg from '../../../assets/GetImg'
import GH from '../../../helpers/GeneralHelper'
import { withTheme } from '@mui/styles'

const { innerWidth } = window

class Connect extends Component {
    _isMount = false

    constructor(props) {
        super(props)

        this.state = {
            selectedContact: {},
            messageList: [],
            systemMessage: null,
            // map partnerId -> conversation_id for AI chats
            aiConversations: {}
            ,
            // map partnerId or conversationId -> array of messages for quick lookup and persistence
            conversations: {}
            ,
            // set of known aiprofile ids/owner ids for quick lookup
            aiprofileIds: new Set()
            ,
            recentConversations: []
            ,
            recentLimit: 10,
            recentOffset: 0
        }

        this.handleUpdateMessage = this.handleUpdateMessage.bind(this)
        this.handleSwitchChannel = this.handleSwitchChannel.bind(this)
        this.handleSendMessage = this.handleSendMessage.bind(this)
    }

    // Helper to detect if a contact is an AI (comes from aicontact table with aiprofile join)
    isAiContact(contact) {
        return contact && contact.hasOwnProperty('reciever_display_name')
    }


    async componentDidMount() {
        
        // console.log("Starting Mount")
        this._isMount = true
        // console.log(this._isMount)
        
        // Load human contacts
        const userContacts = await UserInteractionHelper.getContactSentByUserId(AuthenticationHelper.uuid)
        const requestedToContact = await UserInteractionHelper.getContactByUserId(AuthenticationHelper.uuid)
        
        // Load AI contacts
        const aiUserContacts = await AiInteractionHelper.getContactSentByUserId(AuthenticationHelper.uuid)
        const aiRequestedToContact = await AiInteractionHelper.getContactByUserId(AuthenticationHelper.uuid)
        
        let contacts = [], noRepeat = []
        // console.log("I am here")
        // console.log(requestedToContact)
        // console.log(userContacts)
        
        // Add human contacts from both directions
        if (requestedToContact.hasOwnProperty('data') && requestedToContact.data !== null && this._isMount) {
            contacts = contacts.concat(requestedToContact.data)
        }
        if (userContacts.hasOwnProperty('data') && userContacts.data !== null && this._isMount) {
            contacts = contacts.concat(userContacts.data)
        }
        
        // Add AI contacts from both directions
        if (aiRequestedToContact.hasOwnProperty('data') && aiRequestedToContact.data !== null && this._isMount) {
            contacts = contacts.concat(aiRequestedToContact.data)
        }
        if (aiUserContacts.hasOwnProperty('data') && aiUserContacts.data !== null && this._isMount) {
            contacts = contacts.concat(aiUserContacts.data)
        }

        noRepeat = []
        const idIndex = {}
        contacts.forEach((item, index) => {
            if (
                noRepeat.findIndex(contact => contact.reciever_id === item.sender_id && contact.sender_id === item.reciever_id) === -1 && // remove sender, reciever cross match items
                noRepeat.findIndex(contact => contact.sender_id === item.sender_id && contact.reciever_id === item.reciever_id) === -1     // remove same sender reciever items
            ) {
                noRepeat.push(item)
                // idIndex[item.contact_id] = item
            }
        })
        // console.log("idx index", idIndex)
        await this.props.updateConnectedUsers(noRepeat)
        await this.props.loopConnectedUsers(noRepeat)

    //get chat account information
        if (!ChatSystemHelper.chatToken) {
            if (await ChatSystemHelper.loginChat(AuthenticationHelper.uuid)) {
                // console.log("logged in to chat successfully")
            }
            else {
                console.log("failed logging in")
            }
        }
        else {
            console.log("socket already exists, resume")
        }

        //subscribe to chatroom
        await ChatSystemHelper.subscribeToChat(AuthenticationHelper.uuid, this.handleUpdateMessage) //chatroomIdList holds all the relationship between roomid and partnerid
        // also connect to AI SSE stream so multiple client sessions receive AI replies in realtime
        try{
            ChatSocketHelper.connectToAI(this.handleUpdateMessage)
        }catch(e){
            console.warn('Failed to initialize AI SSE connection', e)
        }
        // Note: To avoid duplicates in Connect, do not merge AI contacts here.
        // The server mirrors bot interactions into human tables, so the UI should
        // only use human `usercontact` sources for connected users.
        if (this._isMount) {
            this.setState({
                selectedContact: noRepeat[0] || {}
            })
        }
        // Fetch recent AI conversations for this user (paginated)
        try{
            await this.loadRecentConversations()
        }catch(e){
            console.warn('Failed to load recent AI conversations', e)
        }
        // Load AI profile ids and a lookup by display_name to determine bot_id from human contact name
        try {
            const resp = await AIProfileHelper.getAllProfiles()
            const list = (resp && Array.isArray(resp.data)) ? resp.data : []
            const ids = new Set()
            const nameToId = {}
            list.forEach(p => {
                if(!p) return
                const id = p.id || p.uuid || p._id
                const name = (p.display_name || p.username || '').toString().trim().toLowerCase()
                if(id) ids.add(String(id))
                if(id && name) nameToId[name] = String(id)
            })
            if (this._isMount) {
                this.setState({ aiprofileIds: ids, aiNameToId: nameToId })
            }
        } catch (e) {
            console.warn('Failed to load AI profiles for id/name mapping', e)
        }
        // Load persisted AI conversation mapping from localStorage for quicker hydration
        try {
            const key = `aiConversations:${AuthenticationHelper.uuid}`
            const raw = localStorage.getItem(key)
            if (raw) {
                const parsed = JSON.parse(raw)
                if (parsed && typeof parsed === 'object' && this._isMount) {
                    this.setState({ aiConversations: parsed })
                }
            }
        } catch (e) {
            console.warn('Failed to load aiConversations from localStorage', e)
        }
        //console.log("Ending Mount")
        //console.log(this._isMount)

    }

    // simple human-friendly time formatter
    formatTime(iso) {
        if(!iso) return ''
        const d = new Date(iso)
        if(isNaN(d.getTime())) return iso
        const now = new Date()
        const diff = Math.floor((now - d) / 1000) // seconds
        if(diff < 60) return 'just now'
        if(diff < 3600) return `${Math.floor(diff/60)}m ago`
        if(diff < 86400) return `${Math.floor(diff/3600)}h ago`
        // fallback to locale date for older
        return d.toLocaleString()
    }

    async loadRecentConversations(limit = null, offset = null) {
        const l = limit === null ? this.state.recentLimit : limit
        const o = offset === null ? this.state.recentOffset : offset
        try{
            const resp = await AIChatHelper.getRecentConversations(l, o)
            const recent = (resp && resp.recent) ? resp.recent : (resp && resp.data ? resp.data : [])
            if (this._isMount) {
                this.setState({ recentConversations: Array.isArray(recent) ? recent : [], recentLimit: l, recentOffset: o })
            }
        }catch(e){
            console.warn('Failed to load recent AI conversations', e)
        }
    }

    async handleRecentPrev() {
        const newOffset = Math.max(0, (this.state.recentOffset - this.state.recentLimit))
        await this.loadRecentConversations(this.state.recentLimit, newOffset)
    }

    async handleRecentNext() {
        const newOffset = this.state.recentOffset + this.state.recentLimit
        await this.loadRecentConversations(this.state.recentLimit, newOffset)
    }
    //TODO: process message into correct rooms with user id
    //[ {partnerid="id", messageList=[]},{partner="id",messageList=[]}]
    processMessageList(MessageList) {
        // console.log('process message called')
        //console.log(MessageList)
        let roomMessage = {}
        //console.log(ChatInfoStore.chatRoomInfo)

        if (ChatInfoStore.chatRoomInfo) {
            ChatInfoStore.chatRoomInfo.forEach((room) => roomMessage[room.partnerId] = [])
        }

        if (MessageList) {
            // console.log(MessageList)
            MessageList.forEach((messageObj) => {
                if (messageObj === undefined) return
                //roomMessage[messageObj]
                // Try to find a chat room mapping for this message.rid
                let roomObj = (ChatInfoStore.chatRoomInfo || []).find(element => element.roomId == messageObj.rid) || {}
                // If we found a partnerId, use it as the grouping key; otherwise use the message.rid itself
                const key = roomObj.partnerId || messageObj.rid
                if (!roomMessage[key]) {
                    roomMessage[key] = [messageObj]
                }
                else {
                    roomMessage[key].push(messageObj)
                }
            })
        }
        // console.log(roomMessage)

        return roomMessage
        // console.log(roomMessage)
    }

    handleUpdateMessage(newMessageList) {
        // console.log("Update message")
        // console.log(newMessageList)
        // console.log(this._isMount)
        if (this._isMount) {
            // merge incoming socket messages into messageList AND into conversations map
            const merged = this.state.messageList.concat(newMessageList)
            const convs = { ...(this.state.conversations || {}) }
            try {
                newMessageList.forEach(m => {
                    // determine partner key: try to map via ChatInfoStore
                    let roomObj = (ChatInfoStore.chatRoomInfo || []).find(element => element.roomId == m.rid) || {}
                    const key = roomObj.partnerId || m.rid
                    if (!convs[key]) convs[key] = []
                    convs[key].push(m)
                })
            } catch (e) {
                console.warn('Failed to merge socket messages into conversations map', e)
            }
            if (this._isMount) {
                this.setState({
                    messageList: merged,
                    conversations: convs
                })
            }
        }
    }

    async handleSendMessage(rid = '', msg = '') {
        if (msg === '') return null
        // If the currently selected contact is an AI profile, route via AI endpoint
        let skipRcFallback = false
        // diagnostic vars declared in outer scope so catch block can inspect them
        let botId = null
        let existingConversationId = null
        let roomId = null
        let sysMsg = null
        let userMessage = null
        try {
            const contact = this.state.selectedContact || {}
            // determine partner id (the other user in this contact relationship)
            const partnerId = (contact.sender_id && contact.reciever_id)
                ? (contact.sender_id === AuthenticationHelper.uuid ? contact.reciever_id : contact.sender_id)
                : null

            // Check if this is an AI contact by checking for reciever_display_name (from aiprofile join)
            const isAi = this.isAiContact(contact)

            // Determine candidate bot id: prefer explicit contact.id (migrated aiprofile id), otherwise partnerId
            // Prefer explicit contact.id (expected to be the aiprofile id for AI contacts), otherwise fall back to partnerId
            let candidateBotId = contact.id || partnerId
            // Only attempt AI when the contact is marked AI, or when the candidate id exists in the aiprofile id set
            const aiSet = this.state.aiprofileIds
            // If we don't have a clear AI marker, try mapping contact display_name -> aiprofile.id using loaded profiles
            if(!isAi){
                try{
                    const name = ((contact.reciever_display_name || contact.sender_display_name || '')+ '').trim().toLowerCase()
                    if(name && this.state.aiNameToId && this.state.aiNameToId[name]){
                        candidateBotId = this.state.aiNameToId[name]
                    }
                }catch(e){ /* noop */ }
            }
            const shouldAttemptAI = !!(isAi || (candidateBotId && aiSet && aiSet.size > 0 && aiSet.has(String(candidateBotId))))
            if (!shouldAttemptAI && candidateBotId && aiSet && aiSet.size > 0) {
                // candidate exists but not present in aiprofile list
                console.warn('Connect: candidate bot id not found in aiprofile list, falling back to normal chat', { candidateBotId })
            }

            if (shouldAttemptAI) {
                skipRcFallback = true
                // send to AI endpoint and persist/display reply
                userMessage = { role: 'user', content: msg }
                // prefer a provided rid; otherwise reuse existing conversation id; otherwise make a deterministic AI rid
                existingConversationId = (partnerId && this.state.aiConversations && this.state.aiConversations[partnerId]) || null
                roomId = rid || existingConversationId || (partnerId ? `ai-${partnerId}` : `ai-${AuthenticationHelper.uuid}`)
                // prefer explicit contact.id when present (this is the aiprofile id). Otherwise use partnerId
                // which, after migration, corresponds to the aiprofile.id for that user.
                botId = candidateBotId
                // include system prompt from cached AI profiles to guarantee server has a prompt
                sysMsg = (this.state.aiPromptMap && botId) ? this.state.aiPromptMap[botId] : null
                // optimistic typing bubble while waiting for AI
                const nowIso = new Date().toISOString()
                const makeId = () => `${Date.now()}-${Math.random().toString(36).slice(2,9)}`
                const typingId = makeId()
                const typingMsg = { _id: typingId, rid: existingConversationId || roomId, msg: 'typing…', u: { username: botId }, ts: { $date: nowIso }, _typing: true }
                if (this._isMount) {
                    const updatedListPre = this.state.messageList.concat([{ _id: makeId(), rid: existingConversationId || roomId, msg: msg, u: { username: AuthenticationHelper.uuid }, ts: { $date: nowIso } }, typingMsg])
                    const convsPre = { ...(this.state.conversations || {}) }
                    const partnerKeyPre = partnerId || botId
                    if (!convsPre[partnerKeyPre]) convsPre[partnerKeyPre] = []
                    convsPre[partnerKeyPre] = convsPre[partnerKeyPre].concat([{ _id: makeId(), rid: existingConversationId || roomId, msg: msg, u: { username: AuthenticationHelper.uuid }, ts: { $date: nowIso } }, typingMsg])
                    if (existingConversationId) {
                        if (!convsPre[existingConversationId]) convsPre[existingConversationId] = []
                        convsPre[existingConversationId] = convsPre[existingConversationId].concat([{ _id: makeId(), rid: existingConversationId, msg: msg, u: { username: AuthenticationHelper.uuid }, ts: { $date: nowIso } }, typingMsg])
                    }
                    this.setState({ messageList: updatedListPre, conversations: convsPre })
                }

                const res = await AIChatHelper.sendMessage({ conversationId: existingConversationId, messages: [userMessage], bot_id: botId, systemMessage: sysMsg, room_id: roomId })
                // prefer to persist/use the conversation id returned by the AI endpoint
                const conversationId = res && (res.conversation_id || res.conversationId || res.conversation)
                // save mapping partnerId -> conversationId so subsequent messages use the same conversation
                if (conversationId && partnerId) {
                    const newMap = { ...(this.state.aiConversations || {}) }
                    newMap[partnerId] = conversationId
                    this.setState({ aiConversations: newMap })
                    try {
                        const key = `aiConversations:${AuthenticationHelper.uuid}`
                        localStorage.setItem(key, JSON.stringify(newMap))
                    } catch (e) {
                        console.warn('Failed to persist aiConversations to localStorage', e)
                    }
                }
                // append both user and assistant to local messageList for immediate UI feedback
                const assistantContent = res && res.assistant && res.assistant.content ? res.assistant.content : null
                const ridToUse = conversationId || existingConversationId || roomId
                if (this._isMount) {
                    const typingReplace = (finalContent) => {
                        // estimate a natural delay based on content length (chars per second ~35)
                        const len = (finalContent || '').length
                        const delayMs = Math.min(3000, Math.max(600, Math.round((len / 35) * 1000)))
                        setTimeout(() => {
                            try {
                                // replace typing bubble with final assistant message
                                const updatedList = this.state.messageList.map(m => (m._id === typingId ? { ...m, msg: finalContent, _typing: false, rid: ridToUse } : m))
                                const convs = { ...(this.state.conversations || {}) }
                                Object.keys(convs).forEach(k => {
                                    convs[k] = (convs[k] || []).map(m => (m._id === typingId ? { ...m, msg: finalContent, _typing: false, rid: ridToUse } : m))
                                })
                                this.setState({ messageList: updatedList, conversations: convs })
                            } catch (e) {
                                console.warn('Failed to replace typing bubble', e)
                            }
                        }, delayMs)
                    }
                    if (assistantContent) {
                        typingReplace(assistantContent)
                    } else {
                        // no reply content; remove typing bubble
                        const updatedList = this.state.messageList.filter(m => m._id !== typingId)
                        const convs = { ...(this.state.conversations || {}) }
                        Object.keys(convs).forEach(k => {
                            convs[k] = (convs[k] || []).filter(m => m._id !== typingId)
                        })
                        this.setState({ messageList: updatedList, conversations: convs })
                    }
                }
                return true
            }
        } catch (e) {
            try {
                console.warn('AI send failed', e)
                // Log diagnostic context to help debugging server/client mismatch
                console.warn('AI send diagnostics', {
                    botId: botId,
                    conversationId: existingConversationId,
                    roomId: roomId,
                    sysMsgPresent: !!sysMsg,
                    sysMsgPreview: sysMsg ? (typeof sysMsg === 'string' ? sysMsg.slice(0,200) : JSON.stringify(sysMsg).slice(0,200)) : null,
                    messagesPreview: JSON.stringify([userMessage]).slice(0,400),
                    errorMessage: e && e.message ? e.message : String(e)
                })
            } catch (logErr) {
                console.warn('Failed to log AI failure diagnostics', logErr)
            }
            if (skipRcFallback) {
                // For AI conversations, do not fallback to Rocket.Chat
                return null
            }
        }

        // fallback to sending to rocket-chat via websocket (default behavior)
        const contact = this.state.selectedContact || {}
        const partnerId = (contact.sender_id && contact.reciever_id)
            ? (contact.sender_id === AuthenticationHelper.uuid ? contact.reciever_id : contact.sender_id)
            : null
        const finalRid = rid || ChatInfoStore.getRoomId(partnerId)
        if (!finalRid) return null
        ChatSocketHelper.sendMessageToRoom(finalRid, msg, AuthenticationHelper.uuid)
        return true
    }

    handleSwitchChannel(contact) {
        const { connectedUsersJsonIdx } = this.props
        if (contact.hasOwnProperty("contact_id") && contact.contact_id !== '' && this._isMount) {
            let newContact = connectedUsersJsonIdx[contact.contact_id]
            // set selected contact first
            this.setState({ selectedContact: newContact || {} }, async () => {
                try {
                    // attempt to load AI conversation history if we have a mapping for this partner
                    const sel = this.state.selectedContact || {}
                    const partnerId = sel.reciever_id === AuthenticationHelper.uuid ? sel.sender_id : sel.reciever_id
                    let convId = this.state.aiConversations && partnerId ? this.state.aiConversations[partnerId] : null

                    // Immediately show any cached messages for this conversation to avoid a blank screen
                    try {
                        let cacheKey = null
                        if (convId) {
                            cacheKey = `aiMessages:${convId}`
                        } else if (partnerId) {
                            cacheKey = `aiMessages:ai-${partnerId}`
                        }
                        if (cacheKey) {
                            const raw = localStorage.getItem(cacheKey)
                            if (raw) {
                                const cached = JSON.parse(raw)
                                if (Array.isArray(cached) && cached.length > 0) {
                                    const normalized = cached.map(m => ({
                                        _id: m.id || `${Date.now()}-${Math.random().toString(36).slice(2,9)}`,
                                        rid: convId || `ai-${partnerId}`,
                                        msg: m.msg || '',
                                        u: m.u || { username: m.u && m.u.username ? m.u.username : (sel.id || partnerId) },
                                        ts: m.ts || { $date: new Date().toISOString() }
                                    }))
                                    // merge into state BUT do not clobber newer in-memory messages
                                    const convs = { ...(this.state.conversations || {}) }
                                    const partnerKey = partnerId
                                    if (!convs[partnerKey]) convs[partnerKey] = []
                                    const existingPartnerIds = new Set((convs[partnerKey] || []).map(x => x._id))
                                    const addToPartner = normalized.filter(n => !existingPartnerIds.has(n._id))
                                    convs[partnerKey] = (convs[partnerKey] || []).concat(addToPartner)

                                    if (convId) {
                                        if (!convs[convId]) convs[convId] = []
                                        const existingConvIds = new Set((convs[convId] || []).map(x => x._id))
                                        const addToConv = normalized.filter(n => !existingConvIds.has(n._id))
                                        convs[convId] = (convs[convId] || []).concat(addToConv)
                                    }

                                    const existingIds = new Set(this.state.messageList.map(x => x._id))
                                    const toAdd = normalized.filter(n => !existingIds.has(n._id))
                                    if (toAdd.length > 0 || addToPartner.length > 0) {
                                        if (this._isMount) {
                                            this.setState({ messageList: this.state.messageList.concat(toAdd), conversations: convs })
                                        }
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.warn('Failed to load cached aiMessages', e)
                    }
                    // If we don't have a local mapping, try to get-or-create the conversation by bot id
                    let preFetchedResp = null
                    if (!convId) {
                        try {
                            let candidateBotId = sel.id || partnerId
                            const aiSet = this.state.aiprofileIds
                            // Try mapping by display_name if id not clearly AI
                            if(!this.isAiContact(sel)){
                                try{
                                    const name = ((sel.reciever_display_name || sel.sender_display_name || '')+ '').trim().toLowerCase()
                                    if(name && this.state.aiNameToId && this.state.aiNameToId[name]){
                                        candidateBotId = this.state.aiNameToId[name]
                                    }
                                }catch(e){ /* noop */ }
                            }
                            const looksLikeAi = candidateBotId && aiSet && aiSet.size > 0 && aiSet.has(String(candidateBotId))
                            if (looksLikeAi && candidateBotId) {
                                try {
                                    const res = await AIChatHelper.getOrCreateForBot(candidateBotId)
                                    if (res && res.conversation_id) {
                                        convId = res.conversation_id
                                        // save mapping partnerId -> conversationId
                                        const newMap = { ...(this.state.aiConversations || {}) }
                                        newMap[partnerId] = convId
                                        if (this._isMount) {
                                            this.setState({ aiConversations: newMap })
                                        }
                                    }
                                    preFetchedResp = res
                                } catch (e) {
                                    console.warn('Failed to get-or-create AI conversation for bot', e)
                                }
                            }
                        } catch (e) {
                            console.warn('Error determining candidate bot id', e)
                        }
                    }

                    if (convId) {
                        // fetch conversation messages from server (use preFetchedResp if available)
                            try {
                                // Diagnostic: log which conversation id we're requesting and whether a pre-fetched response exists
                                try { console.log('[AI HISTORY] requesting conversation', { convId: convId, hasPrefetch: !!preFetchedResp }) } catch(e){}
                                const resp = preFetchedResp || await AIChatHelper.getConversation(convId)
                                try { console.log('[AI HISTORY] getConversation response', { convId, resp }) } catch(e){}
                                try { window.__lastAIHistoryResp = resp } catch(e) {}
                            if (resp && resp.messages) {
                                // normalize messages into client message shape
                                const normalized = resp.messages.map(m => ({
                                    _id: m.id || (m._id || `${Date.now()}-${Math.random().toString(36).slice(2,9)}`),
                                    rid: convId,
                                    msg: m.content || m.message || '',
                                    u: { username: m.role === 'assistant' ? (sel.id || partnerId) : AuthenticationHelper.uuid },
                                    ts: { $date: m.create_time || m.createTime || new Date().toISOString() }
                                }))
                                // dedupe by _id for messageList
                                const existingIds = new Set(this.state.messageList.map(x => x._id))
                                const toAdd = normalized.filter(n => !existingIds.has(n._id))

                                // also merge into conversations map so switching tabs preserves view
                                const convs = { ...(this.state.conversations || {}) }
                                const partnerKey = partnerId
                                if (!convs[partnerKey]) convs[partnerKey] = []
                                // dedupe for convs[partnerKey]
                                const existingPartnerIds = new Set((convs[partnerKey] || []).map(x => x._id))
                                const addToPartner = normalized.filter(n => !existingPartnerIds.has(n._id))
                                convs[partnerKey] = (convs[partnerKey] || []).concat(addToPartner)

                                // also index by conversation id
                                if (!convs[convId]) convs[convId] = []
                                const existingConvIds = new Set((convs[convId] || []).map(x => x._id))
                                const addToConv = normalized.filter(n => !existingConvIds.has(n._id))
                                convs[convId] = (convs[convId] || []).concat(addToConv)

                                if (toAdd.length > 0 || addToPartner.length > 0 || addToConv.length > 0) {
                                    if (this._isMount) {
                                        this.setState({ messageList: this.state.messageList.concat(toAdd), conversations: convs }, () => {
                                            // persist a local cache of recent messages for this conversation id
                                            try {
                                                const cacheKey = `aiMessages:${convId}`
                                            // store last 50 messages
                                            const items = (convs[convId] || []).slice(-50).map(m => ({ id: m._id, msg: m.msg, u: m.u, ts: m.ts }))
                                            localStorage.setItem(cacheKey, JSON.stringify(items))
                                        } catch (e) {
                                            console.warn('Failed to persist aiMessages to localStorage', e)
                                        }
                                        });
                                    }
                                }
                            } else {
                                // Fallback: ensure AIMessageHandler receives history via ChatSocketHelper
                                try {
                                    // ChatSocketHelper will normalize and emit messages to the same handler
                                    await ChatSocketHelper.getMessagesFromAIConversation(convId)
                                } catch (e) {
                                    console.warn('Fallback AI history load failed', e)
                                }
                            }
                        } catch (e) {
                            console.warn('Failed to load AI conversation messages', e)
                            // Additional fallback attempt
                            try {
                                await ChatSocketHelper.getMessagesFromAIConversation(convId)
                            } catch (e2) {
                                console.warn('Fallback AI history load failed', e2)
                            }
                        }
                    }
                } catch (e) {
                    console.warn('Error while switching channel and loading AI conversation', e)
                }
            })
            return
        }
        // if(!senderId || senderId === '' || !receiverId || receiverId === '') return false
        // console.log(`The sender id is ${senderId} and receiver id is ${receiverId}`)
    }

    componentWillUnmount() {
        //console.log("Unmounted")
        this._isMount = false
        ChatInfoStore.resetChatInfo()
        //console.log(this._isMount)
    }

    render() {
        const { profile, theme } = this.props
        const { selectedContact } = this.state
        let lang = this.props.lang.connect
        let senderId = AuthenticationHelper.uuid
        let currentMsgObj = {}, msgArr = []
        if (this.state.messageList.length > 0) {
            // console.log(this.state.messageList)
            currentMsgObj = { ...this.processMessageList(this.state.messageList) }
            // console.log(currentMsgObj)
        }
        // console.log(currentMsgObj)
        // console.log(ChatInfoStore.chatRoomInfo)
        // console.log(this.state.selectedContact.hasOwnProperty('reciever_id'))
        // console.log(`current selected contact`, selectedContact)
        // If this partner has an AI conversation id tracked, prefer messages grouped by that conversation id
        let partnerid = ""
        if (this.state.selectedContact.reciever_id === AuthenticationHelper.uuid) {
            partnerid = this.state.selectedContact.sender_id
        }
        else {
            partnerid = this.state.selectedContact.reciever_id
        }

        const convIdForPartner = this.state.aiConversations && partnerid ? this.state.aiConversations[partnerid] : null

        // Prefer messages stored in our conversations map (merged socket + AI history)
        const convs = this.state.conversations || {}
        if (convs[partnerid] && convs[partnerid].length > 0) {
            msgArr = ChatSocketHelper.sortMessageByDates([...convs[partnerid]])
        } else if (convIdForPartner && convs[convIdForPartner] && convs[convIdForPartner].length > 0) {
            msgArr = ChatSocketHelper.sortMessageByDates([...convs[convIdForPartner]])
        } else if (convIdForPartner && currentMsgObj.hasOwnProperty(convIdForPartner)) {
            msgArr = ChatSocketHelper.sortMessageByDates([...currentMsgObj[convIdForPartner]])
        } else if (currentMsgObj.hasOwnProperty(this.state.selectedContact.reciever_id)) {
            // console.log('receiver id')
            //    console.log(currentMsgObj[this.state.selectedContact.reciever_id])
            // remember to reverse the array to reveal the real sequence of the messages
            msgArr = ChatSocketHelper.sortMessageByDates([...currentMsgObj[this.state.selectedContact.reciever_id]])
        }

        if (currentMsgObj.hasOwnProperty(this.state.selectedContact.sender_id)) {
            // console.log('sender id')
            msgArr = ChatSocketHelper.sortMessageByDates([...currentMsgObj[this.state.selectedContact.sender_id]])
        }

        // console.log(senderId)
        // console.log("selected contact", this.state.selectedContact)

        // console.log(msgArr)
        // console.log(this.props)
        let matches = [], matchesfull = []
        // console.log("connected users", this.props.connectedUsers)
        // console.log(this.props.matches)
        if (this.props.connectedUsers.length > 0) {
            this.props.connectedUsers.forEach((m, idx) => {
                // console.log(m)
                const contactId = m.contact_id
                const display_name = m.hasOwnProperty('reciever_display_name') ? m.reciever_display_name : m.sender_display_name
                // Fallback to 'Unknown' if display_name is undefined
                const safeDisplayName = display_name || 'Unknown'
                const initials = safeDisplayName.length > 1 ? `${safeDisplayName[0].toUpperCase()}${safeDisplayName[1].toUpperCase()}` : `${safeDisplayName[0].toUpperCase()}`
                matches.push(<Tab
                    // label={display_name}
                    key={`connect-tab-${idx}`}
                    value={contactId}
                    icon={<Avatar sx={{
                        width: {
                            md: '72px',
                            sm: '72px',
                            xs: '48px'
                        },
                        height: {
                            md: '72px',
                            sm: '72px',
                            xs: '48px'
                        },
                        bgcolor: 'primary.main',
                        m: 'auto'
                    }}>{initials}</Avatar>} />)
                    matchesfull.push(<Tab
                        key={`connect-tab-full-${idx}`}
                        label={safeDisplayName}
                        value={contactId}
                        icon={<Avatar sx={{
                            width: {
                                md: '72px',
                                sm: '72px',
                                xs: '48px'
                            },
                            height: {
                                md: '72px',
                                sm: '72px',
                                xs: '48px'
                            },
                            bgcolor: 'primary.main',
                            m: 'auto'
                        }}>{initials}</Avatar>} />)
                // matches.push(
                // <ChatAvatarContainer 
                //     key={`match-chat-${idx}`}
                //     active={m.contact_id === this.state.selectedContact.contact_id || false}
                //     contact={m}
                //     contactId={m.contact_id}
                //     currentSelectedContact={this.state.selectedContact}
                //     senderId={senderId}
                //     receiverId={m.reciever_id === senderId ? m.sender_id : m.reciever_id}
                //     display_name={m.hasOwnProperty('reciever_display_name') ? m.reciever_display_name:m.sender_display_name} 
                //     onClick={this.handleSwitchChannel} 
                // />)
            })
            // console.log(this.state.messageList)
            // let ownMessages = [], otherMessages = [], selectedMsgs = this.state.messageList.hasOwnProperty(this.state.selectedContact.contact_id) ? this.state.messageList[this.state.selectedContact.contact_id] : []
            // this.state.messageList.forEach((msg, idx) => {

            // })

            /*get partner id */
            let partnerid = ""
            if (this.state.selectedContact.reciever_id === AuthenticationHelper.uuid) {
                partnerid = this.state.selectedContact.sender_id
            }
            else {
                partnerid = this.state.selectedContact.reciever_id
            }

            return (<React.Fragment>
                <Grid item xs sx={{
                    px: {
                        xs: 0,
                        sm: 2,
                        md: 2
                    },
                    pb: {
                        xs: 0,
                        sm: 2
                    }
                }}>
                    <Stack direction={{
                        xs: "column",
                        sm: "row"
                    }} 
                    // rowSpacing={2}
                        sx={{
                            boxShadow: 2
                        }}
                    >
                        
                        {/** chat avatar*/}
                        <Box item xs
                            sx={{
                                maxWidth: theme => theme.maxavatar,
                                // boxShadow: 1
                            }}
                        >
                            <Grid container
                                sx={{
                                    // boxShadow: 2,
                                    mx: 'auto',
                                }}
                            >
                                <Box sx={{
                                    display: {
                                        xs: 'block',
                                        sm: 'none',
                                        md: 'none'
                                    },
                                    maxWidth: {
                                        xs: 'xs'
                                    },
                                    bgcolor: 'background.default'
                                }}>
                                    <Tabs
                                        value={(Array.isArray(this.props.connectedUsers) && this.props.connectedUsers.map(u => u.contact_id).includes(selectedContact?.contact_id))
                                            ? selectedContact.contact_id
                                            : (this.props.connectedUsers && this.props.connectedUsers[0] ? this.props.connectedUsers[0].contact_id : false)}
                                        // value={0}
                                        onChange={(e, v) => {
                                            // console.log(e)
                                            this.handleSwitchChannel({
                                                contact_id: v
                                            })
                                        }}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs"
                                        // scrollButtons={true}
                                        allowScrollButtonsMobile
                                    >
                                        {matches}
                                    </Tabs>
                                </Box>

                                <Box sx={{
                                    display: {
                                        xs: 'none',
                                        sm: 'block',
                                        md: 'block'
                                    },
                                    maxWidth: theme => theme.maxavatar,
                                    bgcolor: 'background.default'
                                }}>
                                    <Tabs
                                        value={(Array.isArray(this.props.connectedUsers) && this.props.connectedUsers.map(u => u.contact_id).includes(selectedContact?.contact_id))
                                            ? selectedContact.contact_id
                                            : (this.props.connectedUsers && this.props.connectedUsers[0] ? this.props.connectedUsers[0].contact_id : false)}
                                        // value={0}
                                        onChange={(e, v) => {
                                            // console.log(e)
                                            this.handleSwitchChannel({
                                                contact_id: v
                                            })
                                        }}
                                        orientation="vertical"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs"
                                        // scrollButtons={true}
                                        allowScrollButtonsMobile
                                        sx={{
                                            maxWidth: theme => theme.maxavatar
                                        }}
                                    >
                                        {matchesfull}
                                    </Tabs>
                                </Box>
                                
                            </Grid>
                        </Box>
                        <Divider sx={{
                            display: {
                                xs: 'none',
                                sm: 'flex'
                            }
                        }} orientation="vertical" flexItem />
                        {/** chat window */}
                        <Box
                            sx={{
                                position: 'relative',
                                width: 1,
                                minWidth: {
                                    xs: 1,
                                    sm: theme.maxwidth - 96
                                }
                            }}
                        >
                            
                            {/** profile display */}
                            <Stack direction={"row"} sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%',
                                alignItems: 'center',
                                py: {
                                    xs: 1,
                                    sm: 2,
                                    md: 2
                                },
                                px: {
                                    xs: 1,
                                    sm: 3,
                                    md: 3
                                },
                                boxShadow: 2,
                            }}>
                                <Accordion
                                    sx={{
                                        bgcolor: 'background.default',
                                        width: '100%',
                                        boxShadow: 0,
                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="chat title"
                                        id="chat-window-header"
                                    >
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box>
                                                    <Paragraph variant="body1">{selectedContact.hasOwnProperty('reciever_display_name') ? selectedContact.reciever_display_name : selectedContact.sender_display_name}</Paragraph>
                                                    <Paragraph variant="body1" sx={{ color: 'primary.main', display: { md: 'block', sm: 'none', xs: 'none' } }}>{`${selectedContact?.sender_age}, ${selectedContact?.sender_gender}, ${selectedContact?.sender_address || ''}`}</Paragraph>
                                                </Box>
                                                <Box>
                                                    {/* AI mode removed — chat will only be human by default. */}
                                                </Box>
                                            </Box>

                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box>
                                            <Paragraph variant="body2" sx={{ color: 'primary.main' }}>{`${(lang?.problemCategory ?? 'Problem category')}:`}</Paragraph>
                                            <Paragraph variant="body2">{selectedContact?.problem_category_1 ? `• ${selectedContact.problem_category_1}` : ''}</Paragraph>
                                            <Paragraph variant="body2">{selectedContact?.problem_category_2 ? `• ${selectedContact.problem_category_2}` : ''}</Paragraph>
                                            <Paragraph variant="body2">{selectedContact?.problem_category_3 ? `• ${selectedContact.problem_category_3}` : ''}</Paragraph>
                                        </Box>
                                        <Box sx={{ mt: 1 }}>
                                            <Paragraph variant="body2" sx={{ color: 'primary.main' }}>{`${(lang?.studyField ?? 'Study field')}:`}</Paragraph>
                                            <Paragraph variant="body2">{`${(selectedContact?.study_field ?? '-')}`}</Paragraph>
                                            <Paragraph variant="body2" sx={{ color: 'primary.main', mt: 1 }}>{`${(lang?.LivingSituation ?? 'Living situation')}:`}</Paragraph>
                                            <Paragraph variant="body2">{`${(selectedContact?.living_situation ?? '-')}`}</Paragraph>
                                        </Box>
                                        <Box sx={{ mt: 1 }}>
                                            <Paragraph variant="body2" sx={{ color: 'primary.main' }}>{`${(lang?.copingStrategy ?? 'Coping strategy')}:`}</Paragraph>
                                            <Paragraph variant="body2">{selectedContact?.coping_strategy_1 ? `• ${selectedContact.coping_strategy_1}` : ''}</Paragraph>
                                            <Paragraph variant="body2">{selectedContact?.coping_strategy_2 ? `• ${selectedContact.coping_strategy_2}` : ''}</Paragraph>
                                            <Paragraph variant="body2">{selectedContact?.coping_strategy_3 ? `• ${selectedContact.coping_strategy_3}` : ''}</Paragraph>
                                        </Box>

                                        <Box sx={{ mt: 1 }}>
                                            <Paragraph variant="body2" sx={{ color: 'primary.main' }}>{lang?.hobbies ?? 'Hobbies'}</Paragraph>
                                            <Paragraph variant="body2">{`${selectedContact?.hobbies_description ?? '-'}`}</Paragraph>
                                        </Box>

                                    </AccordionDetails>
                                </Accordion>

                                <Box>
                                <IconButton 
                                    sx={{
                                        display:{
                                            xs: 'none',
                                            sm: 'flex',
                                            md: 'flex',
                                            lg: 'flex',
                                            xl: 'flex'
                                        }
                                    }}
                                    onClick={() => {
                                        const isAiSelected = this.isAiContact(selectedContact)
                                        const rid = isAiSelected
                                            ? ((this.state.aiConversations && this.state.aiConversations[partnerid]) || `ai-${partnerid}`)
                                            : (ChatInfoStore.getRoomId(partnerid))
                                        this.handleSendMessage(rid, 'HugCode')
                                    }}
                                    color={'lightBtn'}
                                    title={lang?.hug ?? 'Hug'} 
                                        icon={<Icons.HugsCountIcon style={{
                                            width: '100%'
                                        }} />} />

                                    <MUIIconButton
                                        onClick={() => {
                                            const isAiSelected = this.isAiContact(selectedContact)
                                            const rid = isAiSelected
                                                ? ((this.state.aiConversations && this.state.aiConversations[partnerid]) || `ai-${partnerid}`)
                                                : (ChatInfoStore.getRoomId(partnerid))
                                            this.handleSendMessage(rid, 'HugCode')
                                        }}
                                        sx={{
                                            width: {
                                                xs: '48px',
                                                sm: '64px',
                                                md: '64px'
                                            },
                                            display:{
                                                xs: 'flex',
                                                sm: 'none',
                                                md: 'none',
                                                lg: 'none',
                                                xl: 'none'
                                            },
                                            borderRadius: 2,
                                            bgcolor: 'background.default',
                                            boxShadow: 2
                                        }}>
                                        <Icons.HugsCountIcon style={{
                                            width: '100%'
                                        }} />

                                    </MUIIconButton>
                                </Box>
                            </Stack>

                            <Divider />
                            

                            {/** chat bubbles display */}
                            <MsgUnitGroup {...this.props} msgArr={msgArr} senderId={senderId} lang={lang} >

                            </MsgUnitGroup>


                            <Grid item
                                sx={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    zIndex: 999,
                                    // maxWidth: theme.maxwidth,
                                    backgroundColor: theme.palette.background.default,
                                    ml: 'auto',
                                    mr: 'auto',
                                    pt: 0
                                }}
                            >
                                <Divider />
                                {(() => {
                                    const isAiSelected = this.isAiContact(selectedContact)
                                    const rid = isAiSelected
                                        ? ((this.state.aiConversations && this.state.aiConversations[partnerid]) || `ai-${partnerid}`)
                                        : (ChatInfoStore.getRoomId(partnerid))
                                    return <SendPanel lang={lang} display_name={this.props?.profile?.display_name} rid={rid} handleSendMessage={this.handleSendMessage} />
                                })()}
                            </Grid>
                        </Box>

                    </Stack>

                </Grid>


            </React.Fragment>)
        }
        return (<Grid item className='my-4'>
            <Paragraph className='fyw-font-dark'>{lang.noContact}</Paragraph>
        </Grid>)
    }
}

const ChatHeader = props => {
    return (<Grid className='p-4 text-center'>
        <Text className='fyw-font-white'>
            {props.title.toUpperCase()}
        </Text>
    </Grid>)
}

const ChatAvatarContainer = props => {

    if (!props.hasOwnProperty('currentSelectedContact') && !props.currentSelectedContact.hasOwnProperty('contact_id') && props.currentSelectedContact.contact_id === ''
        && !props.hasOwnProperty('contact') && !props.contact.hasOwnProperty('contact_id') && props.contact.contact_id === '') return null
    console.log(`the given contact is ${props.contactId}`)
    const safeDisplayName = props.display_name || 'Unknown'
    const initials = safeDisplayName.length > 1 ? `${safeDisplayName[0].toUpperCase()}${safeDisplayName[1].toUpperCase()}` : `${safeDisplayName[0].toUpperCase()}`
    return <Tab
        label={`${safeDisplayName}`}
        value={props.contactId}
        icon={<Avatar sx={{
            width: {
                md: '72px',
                sm: '72px',
                xs: '48px'
            },
            height: {
                md: '72px',
                sm: '72px',
                xs: '48px'
            },
            bgcolor: 'primary.main'
        }}>{initials}</Avatar>} />
    // return (<div className={props.active ? `pl-4 d-flex align-items-center cursor-pointer match-chat-avatar-active`: `pl-4 d-flex align-items-center cursor-pointer`} onClick={() => props.onClick(props.contact)}>
    //     <ChatAvatar {...props} />
    //     <Tip className={props.active ? 'ml-2 my-auto p-0 fyw-font-dark':'ml-4 my-auto p-0 fyw-font-white'}>{props.display_name}</Tip>
    // </div>)
}

const ChatAvatar = props => {
    // console.log(props)
    if (!props.hasOwnProperty('display_name') || props.display_name === null || props.display_name === undefined) return <CircularProgress />
    return (<div className='match-avatar-sm midgreen-avatar cursor-pointer my-2'>
        <Paragraph className='p-0 m-0'>{props.display_name.length > 1 ? `${props.display_name[0].toUpperCase()}${props.display_name[1].toUpperCase()}` : `${props.display_name[0].toUpperCase()}`}</Paragraph>
    </div>)
}

const ChatInformationPanel = props => {
    // console.log(props)
    if (!props.hasOwnProperty('contact') || Object.keys(props.contact).length < 0 || !props.contact.hasOwnProperty('contact_id')) {
        return <CircularProgress />
    }
    return (
        <Grid container direction='column'>

            <Grid item xs={12} className='d-flex justify-content-between align-items-center px-3'>
                <ChatAvatar display_name={props.contact.hasOwnProperty('reciever_display_name') ? props.contact.reciever_display_name : props.contact.sender_display_name} />
                <Tip>{props.contact.hasOwnProperty('reciever_display_name') ? props.contact.reciever_display_name : props.contact.sender_display_name}</Tip>
                <GetImg
                    className={['match-avatar-sm']}
                    imageUrl={'chat-hug-icon.svg'}
                    alt={'information'}
                />
            </Grid>

            <Grid item xs={12} className='chat-story-container pl-3 py-3'>
                <Tip className='p-0 m-0 fyw-font-grey'>{props.contact.hasOwnProperty('reciever_display_name') ? `${props.contact.reciever_age} ${GH.capitalizeFirstLetter(props.contact.reciever_gender)} ${props.contact.reciever_address}` : `${props.contact.sender_age} ${GH.capitalizeFirstLetter(props.contact.sender_gender)} ${props.contact.sender_address}`}</Tip>
                <Tip className='p-0 m-0 fyw-font-grey'>{props.contact.hasOwnProperty('reciever_display_name') ? `${props.lang.lost_relationship}: ${props.contact.reciever_relationship}` : `${props.lang.lost_relationship}: ${props.contact.sender_relationship}`}</Tip>
                <Tip className='p-0 m-0 fyw-font-grey'>{props.contact.hasOwnProperty('reciever_display_name') ? `${props.contact.reciever_loss_description}` : `${props.contact.sender_loss_description}`}</Tip>
            </Grid>

        </Grid>
    )
}

const SendPanel = props => {
    // console.log(props)
    // const initMsg = props.supportMsg !== '' ? props.supportMsg : ''
    // const [comment, updateComment] = useState(initMsg)
    // const [commentError, updateCommentError] = useState('')
    // const [msgSent, updateMsgSent] = useState(initMsg !== '')

    let [message, updateMessage] = useState('')
    const {lang} = props

    const sendMessage = async () => {
        props.handleSendMessage(props.rid, message)
        updateMessage('')
        // const result = await props.login(GH.removeWhiteSpace(email), GH.removeWhiteSpace(password))
        // if(!result) return updateLoginError(props.lang.loginError)
    }

    const handleSubmit = async (e) => {
        // e.preventDefault()
        if (e.key === 'Enter' || e.keyCode === 13) {
            return sendMessage()
        }
        // return e.preventDefault()
    }

    return (<React.Fragment>
        <Grid container direction={'row'} justify={"center"} align={"center"} sx={{
            display: 'relative',
            maxWidth: 1,
            maxHeight: {
                xs: 72,
                sm: 72,
                md: 72
            },
            minHeight: 72,
            // py: {
            //     xs: 2, sm: 2, md: 2
            // },
            px: {
                xs: 2
            }
        }}>
            <Grid item xs={1.5} sm={1} md={1}
                sx={{
                    my: 'auto',
                    display: {
                        xs: 'none',
                        sm: 'block',
                        md: 'block'
                    }
                }}
            >
                <Avatar sx={{
                    width: {
                        md: '36px',
                        sm: '36px',
                        xs: '36px'
                    },
                    height: {
                        md: '36px',
                        sm: '36px',
                        xs: '36px'
                    },
                    m: 'auto',
                    bgcolor: 'primary.main'
                }}>{(props.display_name || 'U').length > 1 ? `${(props.display_name || 'U')[0].toUpperCase()}${(props.display_name || 'U')[1].toUpperCase()}` : `${(props.display_name || 'U')[0].toUpperCase()}`}</Avatar>
            </Grid>
            <Grid item xs sm md sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                // px: 1,
                maxHeight: 64,
                my: 'auto'
            }}>
                <form
                    style={{
                        width: '100%'
                    }}
                    onSubmit={(e) => {
                        e.preventDefault()
                        sendMessage()
                    }}
                >
                    <MessengerInput

                        // placeholder={lang.leaveMessage}
                        // onChange={e => updateSupportMsg(e.target.value)}
                        value={message}

                        // ref={password => this._password = password}
                        type={"text"}
                        // label={props.name !== null ? `${props.lang.leaveMessageTo} (${props.name})`: props.lang.leaveMessage}
                        // ariaLabel='Supportive message'
                                            placeholder={lang?.typeSomething ?? 'Type something…'}
                        // icon='envelope'
                        // withAdornment
                        // endAdornmentIcon={'paper-plane'}
                        // endAdornmentLabel='send'
                        // handleEndAdornmentClick={() => {
                        //     props.sendSupportMsg(comment)
                        //     updateMsgSent(true)
                        // }} 
                        // error={commentError}
                        // helperText={`${comment.length}/250 ${props.lang.words}`}
                        onChange={e => {

                            // console.log(e.target.value.length)
                            // if(e.target.value.length > 250)
                            // {
                            //     updateCommentError(`${props.lang.exceeds} ${comment.length}/250 ${props.lang.words}`)
                            //     updateComment(e.target.value)
                            //     return
                            // }
                            // updateCommentError('')
                            updateMessage(e.target.value)
                        }}
                    />
                </form>

            </Grid>
            <Grid item
                sx={{
                    width: 56,
                    my: 'auto'
                }}
            >
                <MUIIconButton color="primary" aria-label="send the supportive message"
                    sx={{
                        height: 56,
                        width: 56
                    }}
                    onClick={() => {
                        sendMessage()
                    }}
                >
                    <Icons.SendIcon style={{ width: '100%' }} />
                </MUIIconButton>
            </Grid>
        </Grid>
    </React.Fragment>)
    // console.log(props)
    // let [message, updateMessage] = useState('')

    // const sendMessage = async () => {
    //     props.handleSendMessage(props.rid, message)
    //     updateMessage('')
    //     // const result = await props.login(GH.removeWhiteSpace(email), GH.removeWhiteSpace(password))
    //     // if(!result) return updateLoginError(props.lang.loginError)
    // }

    // const handleSubmit = async (e) => {
    //     // e.preventDefault()
    //     if(e.key === 'Enter' || e.keyCode === 13)
    //     {
    //         return sendMessage()
    //     }
    //     // return e.preventDefault()
    // }

    // return (<Grid item xs={12} className={props.className || ''} style={props.style || {}} onKeyPress={handleSubmit} >
    //     <TextInput 
    //         // ref={password => this._password = password}
    //         type={"text"}
    //         label={``}
    //         ariaLabel='Supportive message'
    //         placeholder={`Enter your message...`}
    //         // icon='envelope'
    //         withAdornment
    //         value={message}
    //         endAdornmentIcon={'paper-plane'}
    //         endAdornmentLabel='send'
    //         handleEndAdornmentClick={async () => {
    //             props.handleSendMessage(props.rid, message)
    //             updateMessage('')
    //             // props.sendSupportMsg(comment)
    //             // updateMsgSent(true)
    //         }} 
    //         // error={commentError}
    //         // helperText={`${comment.length}/250 ${props.lang.words}`}
    //         onChange={e => updateMessage(e.target.value)}
    //     />
    // </Grid>)
}

const Message = ({ }) => null
const MessageText = ({ }) => null
const MessageGroup = ({ }) => null

const AlwaysScrollToBottom = () => {
    const elementRef = useRef();
    useEffect(() => elementRef.current.scrollIntoView());
    return <div ref={elementRef} />;
};

const MsgUnitGroup = props => {
    if (props.msgArr === undefined) return null
    let msgUnit = []
    // console.log(props.senderId)
    // console.log(props.msgArr)
    // add username authorName={msg.u.name} 
    props.msgArr.forEach((msg, idx) => {
        const isOwn = props.senderId === msg.u.username
        msgUnit.push(<Box
            key={msg._id}
            sx={{
                maxWidth: '100%',
                width: '100%',
                display: 'flex',
                justifyContent: {
                    xs: isOwn ? 'flex-end' : 'flex-start'
                },
                pr: {
                    xs: 2,
                    sm: 2,
                    md: 2
                },
                px: {
                    xs: 1,
                    sm: 2,
                    md: 2
                },
                pb: 1
            }}
        >
            <Box
                sx={{
                    bgcolor: isOwn ? 'customPink.main' : 'primary.dark',
                    maxWidth: {
                        xs: '280px',
                        sm: '400px',
                        md: '500px',
                        lg: '600px'
                    },
                    border: '1px solid',
                    borderColor: 'primary.dark',
                    borderRadius: 2,
                    px: {
                        xs: 2,
                        sm: 2,
                        md: 2
                    },
                    py: {
                        xs: 0.5,
                        sm: 1,
                        md: 1
                    }
                }}
            >
                {msg._typing ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CircularProgress size={16} color={isOwn ? 'primary' : 'inherit'} />
                        <Paragraph sx={{ color: isOwn ? 'primary.dark' : 'background.default' }}>typing…</Paragraph>
                    </Box>
                ) : (msg.msg !== "HugCode" ?
                    <Paragraph sx={{
                        color: isOwn ? 'primary.dark' : 'background.default'
                    }} align={isOwn ? "right" : "left"}>{msg.msg}</Paragraph>
                    :
                    <Box sx={{
                        width: {
                            xs: '64px',
                            sm: '96px',
                            md: '96px'
                        },
                        height: {
                            xs: '64px',
                            sm: '96px',
                            md: '96px'
                        }
                    }}>
                        {isOwn ? <Icons.HugsCountIcon style={{
                            width: '100%'
                        }} /> :
                            <Icons.HuggedCountIcon style={{
                                width: '100%'
                            }} />
                        }
                    </Box>
                )}

            </Box>
        </Box>)
    })

    if (msgUnit.length > 0) {
        return (
            <Stack direction={"column"} spacing={2} sx={{
                bgcolor: 'background.pink',
                py: {
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 2
                },
                minHeight: '70vh',
                maxHeight: '70vh',
                overflow: 'auto',
                pb: {
                    xs: 9,
                    sm: 9,
                    md: 10,
                    lg: 12,
                    xl: 12
                }
            }}>{msgUnit}
            <AlwaysScrollToBottom />
            {props.children}
            </Stack>
        )
    }

    return <Stack direction={"column"} 
        sx={{
            bgcolor: 'background.pink',
            py: {
                xs: 2,
                sm: 3,
                md: 3,
                lg: 3,
                xl: 3
            },
            px: 2,
            minHeight: '70vh',
            maxHeight: '70vh',
            overflow: 'auto'
        }}
    >
    <Paragraph variant="subtitle1">{props.lang.noMessage}</Paragraph>
    <AlwaysScrollToBottom />
        {props.children}
    </Stack>
}

export default withTheme(Connect)